import $ from "jquery";


let getHrefParam = function(paramName, newHref) {
    let href = newHref || decodeURIComponent((global.location&&(global.location.search||global.location.hash)||"")).substr(1);
    let reg = new RegExp("(^|&|\\?)" + paramName + "=([^&]*)(&|$)");
    let matchResult = href.match(reg);
    let param = matchResult ? decodeURIComponent(matchResult[2]) : "";
    return param;
}
 
if(!$.getHrefParam){
    $.getHrefParam = getHrefParam;
}

export default $;